export const style = {
  button: {
    position: `absolute`,
    zIndex: 99,
    display: `block`,
    height: `34px`,
    width: `34px`,
    border: `0`,
    opacity: `0.08`,
    transition: `0.2s`,
    background: `#A94545`,
    color: `white`,
    fontSize: `16px`,
    ':hover': {
      cursor: `pointer`,
      opacity: `0.8`
    }
  },
  backwards: {
    top: `calc(50% - 12px)`,
    left: `10px`
  },
  forward: {
    top: `calc(50% - 12px)`,
    right: `10px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Slideshow/style/controls.js